import { useQuery } from "@tanstack/react-query";
import { type Dayjs } from "dayjs";

import { type TrainerStats } from "@fitness-app/data-models/entities/TrainerStats";

import { supabase } from "~/store/initializeStore";

export const useTeamMemberMonthStats = ({ month, trainerIds }: { month: Dayjs; trainerIds: string[] }) => {
  const query = useQuery(["teamMemberMonthStats", month, trainerIds], {
    queryFn: async () => {
      if (trainerIds.length === 0) {
        return [];
      }
      let query = supabase.from("trainer_stats").select("*").eq("month", month.format("YYYY-MM"));

      if ((trainerIds.length === 1 && trainerIds[0] !== "all") || trainerIds.length >= 2) {
        query = query.in("trainerId", trainerIds);
      }

      const { data } = await query.throwOnError().overrideTypes<TrainerStats[]>();

      return data;
    },
  });

  return query;
};
